module.exports = __webpack_public_path__ + "img/icon-account-branch-finder@3x.843e2c9f.png";